import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  variant?: 'primary' | 'secondary';
  size?: 'md' | 'lg';
  fullWidthMobile?: boolean;
  showArrow?: boolean;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  children,
  href = '#oferta',
  variant = 'primary',
  size = 'lg',
  fullWidthMobile = true,
  showArrow = false,
  className = '',
  onClick
}: CTAButtonProps) {
  const base = 'inline-flex items-center justify-center gap-2 rounded-xl font-heading uppercase tracking-wide transition-[transform,box-shadow,background-color,border-color] duration-150 ease-out active:translate-y-0';
  const sizeStyles = size === 'lg' ? 'px-7 py-4 text-sm md:text-base' : 'px-5 py-3 text-xs md:text-sm';
  const widthStyles = fullWidthMobile ? 'w-full sm:w-auto' : '';
  const variantStyles = variant === 'primary' ? 'bg-mp-lime text-mp-black font-extrabold hover:brightness-110 hover:-translate-y-0.5 shadow-glow-lime' : 'bg-transparent border border-mp-lime text-mp-white font-bold hover:bg-mp-lime/10 hover:-translate-y-0.5';
  return <a href={href} onClick={onClick} className={`${base} ${sizeStyles} ${widthStyles} ${variantStyles} ${className}`} data-id="element-340" data-mp="3ei9h9f7c76d2">
      {children}
      {showArrow && <ArrowRightIcon className="h-4 w-4 flex-shrink-0" strokeWidth={2.5} data-id="element-341" data-mp="3nglei02pl2eh" />}
    </a>;
}